export enum StatusRodadaPedido {
    AGUARDANDO_CONFIRMACAO = "aguardando_confirmacao",
    EM_PREPARO = "em_preparo",
    ENTREGUE = "entregue",
    CANCELADA = "cancelada",
}

export const StatusRodadaPedidoTitulo: Record<StatusRodadaPedido, string> = {
    [StatusRodadaPedido.AGUARDANDO_CONFIRMACAO]: "Aguardando confirmação",
    [StatusRodadaPedido.EM_PREPARO]: "Em preparo",
    [StatusRodadaPedido.ENTREGUE]: "Entregue",
    [StatusRodadaPedido.CANCELADA]: "Recusada",
};

export const StatusRodadaPedidoCor: Record<StatusRodadaPedido, "warning" | "info" | "success" | "error"> = {
    [StatusRodadaPedido.AGUARDANDO_CONFIRMACAO]: "warning",
    [StatusRodadaPedido.EM_PREPARO]: "info",
    [StatusRodadaPedido.ENTREGUE]: "success",
    [StatusRodadaPedido.CANCELADA]: "error",
};
